<template>
  <div v-if="showModal">
    <transition name="modal">
      <div class="modal-mask">
        <div class="modal-wrapper">
          <div class="modal-dialog" role="document">
            <div class="header">
              <button type="button" class="btn  close-button" @click="closeModal" aria-label="Close">
                <i class="fas fa-times"></i>
              </button>
            </div>
            <div class="modal-body">
              <div class="modal-card">
                <p class="modal-title">Schooljaar {{ getSchoolYear }}</p>
                <div class="divider"></div>
                <div class="month-buttons-wrapper">
                  <button v-for:="month in months" :month="month" class="btn month-select-button text-center"
                          type="button"
                          :class="{ selected: currentDate.getMonth() === month.index, 'current-month': isCurrentMonth(month.index) }"
                          @click="monthClicked(month.index)">{{ month.name }}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </transition>
  </div>

</template>

<script>
  import DateComparison from "@/mixins/DateComparison";

  export default {
    name: "MonthSelectModal",
    components: {},
    mixins: [DateComparison],
    props: {
      showModal: Boolean,
      currentDate: Date
    },
    data() {
      return {
        months: [
          {index: 7, name: "augustus"},
          {index: 8, name: "september"},
          {index: 9, name: "oktober"},
          {index: 10, name: "november"},
          {index: 11, name: "december"},
          {index: 0, name: "januari"},
          {index: 1, name: "februari"},
          {index: 2, name: "maart"},
          {index: 3, name: "april"},
          {index: 4, name: "mei"},
          {index: 5, name: "juni"},
          {index: 6, name: "juli"}
        ],
      }
    },
    computed: {
      todayDate() {
        return new Date();
      },
      getSchoolYear() {
        let month = this.todayDate.getMonth();
        if (month < 7) {
          return (this.todayDate.getFullYear() - 1) + " - " + this.todayDate.getFullYear();
        } else {
          return this.todayDate.getFullYear() + " - " + (this.todayDate.getFullYear() + 1);

        }
      }
    },
    methods: {
      monthClicked(monthIndex) {
        this.$emit("monthPicked", monthIndex);
        this.closeModal();
      },
      closeModal() {
        this.$emit("modalClosed");
      },
      isCurrentMonth(month) {
        return this.todayDate.getMonth() === month;
      }
    },
    created() {
    }
  }
</script>

<style lang="scss" scoped>

  .modal-mask {
    position: fixed;
    z-index: 9998;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(8, 43, 66, .97);
    display: table;
    transition: opacity .3s ease;
  }

  .modal-wrapper {
    display: table-cell;
    vertical-align: middle;
  }

  .modal-dialog {
    pointer-events: all;
  }

  .close-button {
    float: right;
    font-size: 2rem;
    color: $font-light;
    line-height: 1;
  }

  .modal-card {
    background-color: white;
    border-radius: 5px;
    box-shadow: $default-shadow;
    padding: 25px;
    margin-top: 25px;
    display: flex;
    flex-direction: column;

    .modal-title {
      font-size: $title-size;
      margin-bottom: 34px;
    }

    .divider {
      height: 2px;
      background-color: $font-grey;
      margin-bottom: 20px;
    }

    .month-buttons-wrapper {
      display: grid;
      grid-template-columns: repeat(3, 1fr);
      column-gap: 10px;
      row-gap: 10px;
    }

    .month-select-button {
      background-color: white;
      border-radius: 5px;
      box-shadow: $default-shadow;
      color: $font-dark;
      font-size: $body-text-size;
      padding: 1rem 1rem;

      border: 2px solid transparent;

      &:hover {
        background-color: $primary-blue;
        color: $font-light;
      }

      &.selected {
        background-color: $primary-blue;
        color: $font-light;
      }

      &.current-month {
        border-color: $primary-blue;
      }
    }
  }

  .header {
    display: flex;
    height: 50px;
  }

  .container {
    background-color: white;
    border-radius: 5px;
    box-shadow: $default-shadow;
    padding: 25px;
  }


  .title {
    font-size: 1.25rem;
  }

</style>